import { Route } from '@angular/router';

export const parkingManagementRoutes: Route[] = [
  {
    path: ':id/session-list',
    loadComponent: () => import('./pages').then(p => p.ParkingManagementListComponent),
    title: 'UIMS - Parking Sessions',
  },
  {
    path: ':id/session-list/:sessionId',
    loadComponent: () => import('./pages').then(p => p.ParkingSessionDetailsComponent),
    title: 'UIMS - Parking Session Details',
  },
];
